import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import FormControl from '@material-ui/core/FormControl'
import Checkbox from '@material-ui/core/Checkbox'

class EventResultBooleanInput extends Component {
  constructor(props) {
    super(props)
    const {
      eventInfo: { evt_logbook_id, previous_value, value },
    } = props
    this.state = {
      evt_logbook_id,
      previousValue: previous_value,
      value: Boolean(value),
    }
  }

  shouldComponentUpdate(nextProps) {
    const { eventInfo } = nextProps

    if (this.props.eventInfo !== eventInfo) {
      const { evt_logbook_id, previous_value } = eventInfo
      this.setState({
        evt_logbook_id,
        previousValue: previous_value,
      })

      return false
    }

    return true
  }

  onInputChange = e => {
    this.setState(
      {
        value: e.target.checked,
      },
      () => {
        this.props.onValueChange({
          ...this.props.eventInfo,
          value: this.state.value,
          evt_logbook_id: this.state.evt_logbook_id,
          setResultId: this.setResultId,
        })
      },
    )
  }

  setResultId = ({ id }) => {
    this.setState({
      evt_logbook_id: id,
    })
  }

  render() {
    const { tabIndex, dataIndex, disabled } = this.props
    const { value } = this.state

    return (
      <FormControl>
        <Checkbox
          href=""
          checked={value}
          color="primary"
          onChange={this.onInputChange}
          autoFocus={dataIndex === 0}
          inputProps={{
            tabIndex,
            'data-index': dataIndex,
          }}
          className="event-result-field"
          disabled={disabled}
        />
      </FormControl>
    )
  }
}

export default injectIntl(EventResultBooleanInput)
